/**
 * The base type of the task
 */
export enum TaskCode {
  // Notes
  ClinicalImpressionFollowUp = 'task.code.clinicalimpression.followup',
  ClinicalImpressionReview = 'task.code.clinicalimpression.review',

  // Pathology
  ServiceRequestCreate = 'task.code.servicerequest.create',
  DiagnosticReportFollowUp = 'task.code.diagnosticreport.followup',

  // Medication
  MedicationRequestCreate = 'task.code.medicationrequest.create',
  MedicationRequestFollowUp = 'task.code.medicationrequest.followup',

  // Media
  MediaFollowUp = 'task.code.media.followup',

  // Scheduling
  OtherSchedule = 'task.code.other.schedule',
  OtherContact = 'task.code.other.contact',

  // Visits
  OtherHomeVisit = 'task.code.other.homevisit',
  OtherClinicalCallOut = 'task.code.other.clinicalcallout',
}

/**
 * The type of the resource input/output that requires action for task
 */
export enum TaskReferenceType {
  ClinicalImpression = 'task.reference.type.clinicalimpression',
  ServiceRequest = 'task.reference.type.servicerequest',
  DiagnosticReport = 'task.reference.type.diagnosticreport',
  MedicationRequest = 'task.reference.type.medicationrequest',
  Media = 'task.reference.type.media',
}
